// Activity Registration Management Admin Page
// Wrapper for the ActivityRegistrationAdmin component

import React from 'react';
import ActivityRegistrationAdmin from '../../components/admin/ActivityRegistrationAdmin';

const ActivityRegistrationManagement = () => {
  return <ActivityRegistrationAdmin />;
};

export default ActivityRegistrationManagement;
